import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudQuota = (params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}quota/`,
    params: params,
    method: 'get'
  })
}
